// @flow

// import type { Player$Source } from '../types/Source';

const SOURCE_OPTIONS = {
   annotations: null,
   chapters: null,
   cc: null,
   preview: null,
   poster: null,

   title: '',

   nextTrackTitle: '',
   nextTrackThumbnails: '',

   clip: null, // [ 10, 300 ] sec

   // inner props
   isAudio: false
};

export default SOURCE_OPTIONS;
